import _get from 'lodash/get'
import { globalize } from '@/vue/filters/globalize'
import { countries } from 'country-list-json'

const ANNOUNCEMENT_PAGES = [
  {
    id: 'swap',
    value: '/swap',
    label: 'Swap',
  },
  {
    id: 'pools',
    value: '/pools',
    label: 'Pools',
  },
  {
    id: 'privatePools',
    value: '/pools/private',
    label: 'Private pools',
  },
  {
    id: 'sharedPools',
    value: '/pools/shared',
    label: 'Shared pools',
  },
  {
    id: 'myPools',
    value: '/pools/my-pools',
    label: 'My pools',
  },
  {
    id: 'invest',
    value: '/invest',
    label: 'Invest',
  },
  {
    id: 'lend-borrow',
    value: '/lend-borrow',
    label: 'Lend/Borrow',
  },
  {
    id: 'wallet',
    value: '/wallets',
    label: 'Wallet',
  },
  {
    id: 'passport',
    value: '/passport',
    label: 'Passport',
  },
  {
    id: 'dotc-shared',
    value: '/dotc/shared',
    label: 'DOTC shared',
  },
  {
    id: 'dotc-my-offers',
    value: '/dotc/my-offers',
    label: 'DOTC offers',
  },
  {
    id: 'dotc-my-offers',
    value: '/dotc/my-offers',
    label: 'DOTC offers',
  },
  {
    id: 'trade',
    value: '/trade',
    label: 'Trade',
  },
  {
    id: 'trade-swap',
    value: '/trade/swap',
    label: 'Trade swap',
  },
  {
    id: 'trade-limit',
    value: '/trade/limit',
    label: 'Trade limit',
  },
  {
    id: 'discover',
    value: '/discover',
    label: 'Discover',
  },
]
const ANNOUNCEMENT_STATUSES = [
  {
    id: 'waiting',
    label: 'Waiting',
    icon: 'clock-circle',
  },
  {
    id: 'active',
    label: 'Active',
    icon: 'loading-3-quarters',
  },
  {
    id: 'closed',
    label: 'Closed',
    icon: 'check-circle',
  },
]
const ANNOUNCEMENT_STATUSES_AS_OBJECT = {}
ANNOUNCEMENT_STATUSES.forEach(row => {
  ANNOUNCEMENT_STATUSES_AS_OBJECT[row.id] = row.id
})

/* eslint-disable */
Date.prototype.addDays = function (days) {
  let date = new Date(this.valueOf())
  date.setDate(date.getDate() + days)
  return date
}
/* eslint-enable */

class AnnouncementRecord {
  constructor (record) {
    this._record = record

    this.id = _get(record, 'id', 'new')

    const currentDate = new Date()

    this.startDate = new Date(_get(record, 'startDate', currentDate))

    this.endDate = new Date(_get(record, 'endDate', currentDate.addDays(1)))

    const status = _get(record, 'status', null)
    if (status) {
      this.status = status
    } else {
      this.status = this.getStatus()
    }

    this.chainId = _get(record, 'chainId', null)
    this.backgroundColor = _get(record, 'backgroundColor', '#5aa3f2')
    this.label = _get(record, 'label', '')

    this.pages = _get(record, 'pages', []).map(page => {
      const result = ANNOUNCEMENT_PAGES.find(p => p.value === page)
      return result
    })

    this.countries = _get(record, 'countries', []).map(country => {
      const result = countries.find(p => p.code === country)
      return result
    })

    this.createdAt = new Date(_get(record, 'createdAt', new Date()))
    this.icon = this.getIcon(record)
  }

  getStatus () {
    const currentDate = new Date()
    const currDateUnix = currentDate.getTime()
    const startDateUnix = this.startDate.getTime()
    const endDateUnix = this.endDate.getTime()

    if (startDateUnix > currDateUnix) {
      return ANNOUNCEMENT_STATUSES_AS_OBJECT.waiting
    }
    if (startDateUnix >= currDateUnix && endDateUnix >= currDateUnix) {
      return ANNOUNCEMENT_STATUSES_AS_OBJECT.active
    }
    return ANNOUNCEMENT_STATUSES_AS_OBJECT.closed
  }

  getIcon (record) {
    const result = ANNOUNCEMENT_STATUSES.find(r => r.id === record.status)

    return result ? result.icon : ANNOUNCEMENT_STATUSES[0].icon
  }

  updatePages (paths) {
    if (paths.find(p => p === 'all')) {
      this.pages = []
      return
    }
    const newPages = []
    paths.forEach(path => {
      const result = ANNOUNCEMENT_PAGES.find(p => p.value === path)
      if (result) {
        newPages.push(result)
      }
    })
    this.pages = newPages
  }

  updateCountries (paths) {
    if (paths.find(p => p === 'all')) {
      this.countries = []
      return
    }
    const newCountries = []
    paths.forEach(path => {
      const result = countries.find(p => p.code === path)
      if (result) {
        newCountries.push(result)
      }
    })
    this.countries = newCountries
  }

  validate () {
    const errors = []
    if (this.label.length === 0) {
      errors.push({
        valid: false,
        message: globalize('announcement-detail.error-required-label'),
        field: 'label',
      })
    }

    if (this.startDate > this.endDate) {
      errors.push({
        valid: false,
        message: globalize('announcement-detail.error-required-startDate-less'),
        field: 'startDate',
      })
    }
    // if (this.pages.length === 0) {
    //   errors.push({
    //     valid: false,
    //     message: globalize('announcement-detail.error-required-pages'),
    //     field: 'pages',
    //   })
    // }
    // if (this.countries.length === 0) {
    //   errors.push({
    //     valid: false,
    //     message: globalize('announcement-detail.error-required-countries'),
    //     field: 'countries',
    //   })
    // }
    const errorsAsObject = {}

    errors.forEach(error => {
      errorsAsObject[error.field] = error
    })
    return {
      valid: errors.length === 0,
      errors: errorsAsObject,
    }
  }
}

export {
  ANNOUNCEMENT_STATUSES,
  ANNOUNCEMENT_STATUSES_AS_OBJECT,
  ANNOUNCEMENT_PAGES,
  AnnouncementRecord,
}
